/**
 * Utilitaire pour reset la checklist et l'onboarding pour les tests
 * Usage: Dans la console du navigateur, exécuter: window.resetB8ildChecklist()
 */

export function resetChecklistForTesting() {
  // 1. Reset de la checklist onboarding dashboard
  localStorage.removeItem('b8ild_onboarding_checklist_v2');

  // 2. Reset de l'onboarding wizard (première connexion)
  localStorage.removeItem('b8ild_onboarding');

  // 3. Reset du store checklist (zustand persist)
  localStorage.removeItem('b8ild-checklist-store');

  // 4. Reset de la simulation de retard (checklist item)
  localStorage.removeItem('b8ild_tips_retard_seen');

  if (import.meta.env.DEV) {
    console.log('B8ild checklist & onboarding réinitialisés !');
    console.log('Rechargez la page pour voir les changements.');
  }

  // Optionnel: recharger automatiquement
  if (confirm('Voulez-vous recharger la page maintenant ?')) {
    window.location.reload();
  }
}

// Exposer la fonction globalement pour accès depuis la console
if (typeof window !== 'undefined') {
  (window as any).resetB8ildChecklist = resetChecklistForTesting;
}
